export const AnnouncementDefaultFormData = {
	subject: '',
	definition: '',
	recipients: [],
	receiver_slack_channel_ids: [],
	related_resources: [],
};

export type AnnouncementFormKeys = keyof typeof AnnouncementDefaultFormData;

export interface IAnnouncementFieldProps {
	onChange: (key: AnnouncementFormKeys) => (value: string | string[]) => void;
	error?: string | null;
}
